import React from 'react'
import moment from 'moment'
import HeaderCell from './HeaderCell'
import { IColumnDimension } from './calendarTypes'

interface ICalendarHeaderProps {
  firstDay: moment.Moment
  numberOfDays: number
  columnDimensions: IColumnDimension[]
}

const CalendarHeader: React.FC<ICalendarHeaderProps> = ({
  firstDay,
  numberOfDays,
  columnDimensions,
}) => {
  if (columnDimensions.length === 0) {
    return null
  }

  let totalWidth = 0

  const weekdayColumns = Array.from(Array(numberOfDays).keys()).map(
    (_key: unknown, index: number): React.ReactNode => {
      const date = moment(firstDay).add(index, 'd')
      const { width } = columnDimensions[index]
      totalWidth += width
      return (
        <div
          key={index}
          className="weekCalendar__headerColumn"
          style={{ width }}
        >
          <HeaderCell date={date} width={width} />
        </div>
      )
    },
  )

  return (
    <div className="weekCalendar__headerWrapper" style={{ width: totalWidth }}>
      {weekdayColumns}
    </div>
  )
}

export default CalendarHeader
